module.exports = __webpack_public_path__ + "img/truck.d2a87887.svg";